<script>
import Service from '../../../services/fiscal-notification';
import CommonConstants from '../../../common/Constants';
import config from '../../../common/genericPanelConf';
import Utils from '../../../common/Utils';
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import GenericCustomMasterDataAutocompleteV2 from '../../../components/generic/GenericCustomMasterDataAutocompleteV2.vue';
import ResponsiveButton from '../../../components/generic/ResponsiveButton.vue'
import GenericDataTable from '../../../components/generic/GenericDataTable.vue'

export default{
    setup: () => ({ v$: useVuelidate() }),
  components: {
        GenericCustomMasterDataAutocompleteV2,
        ResponsiveButton,
        GenericDataTable
  },
  data(){
    return {
      filters: {
        from:  Utils.formatDatePlusDays(new Date(), -1),
        to:  Utils.formatDatePlusDays(new Date(), -1),
        isDenaturant: true,
        idRegistryPlant: null
      },
      additiveDenaturing: 'DENATURING',
      additiveDenaturingOptions: [
          { label: 'AdditiveReport.denaturing', value: 'DENATURING' },
          { label: 'AdditiveReport.additive', value: 'ADDITIVE' }
      ]
    }
  },
  validations(){
    return {
      filters: {
        from: {required},
        to: {required},
        idRegistryPlant: {},
        isDenaturant: {required}
      }
    }
  },
  computed: {
    constants(){
        return CommonConstants;
    },
    utils(){
      return Utils;
    },
    uiPermissions(){
      return this.$store.getters['security/uiPermissions'];
    }
  },
  created(){
    this.configuration = config.getConfiguration('AdditiveReport');
  },
  mounted(){
    this.$store.dispatch('security/setNavbarTitle', 'AdditiveReport.page_title');
  },
  methods: {
     load(){
        this.submitted = true;

        if(this.v$.invalid){
            return;
        }
        this.submitted = false;

        let filters = {
            from: Utils.formatDateForAPI(Utils.formatDatePlusDays(this.filters.from, 0)),
            to: Utils.formatDateForAPI(Utils.formatEndDate(this.filters.to)),
            isDenaturant: this.additiveDenaturing == 'DENATURING',
            idRegistryPlant: this.filters.idRegistryPlant
        }
        this.$refs.additiveReport.filterFromView(filters, true);
    },
    dowloadReport(){
        this.$store.dispatch("generic/setLoading", true);
        let filters = {
           from: Utils.formatDateForAPI(Utils.formatDatePlusDays(this.filters.from, 0)),
            to: Utils.formatDateForAPI(Utils.formatEndDate(this.filters.to)),
            isDenaturant: this.additiveDenaturing == 'DENATURING',
            idRegistryPlant: this.filters.idRegistryPlant
        }
        Service.printAdditive(filters, response => {
            
            this.$store.dispatch("generic/setLoading", false);
            if(response.success){
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');
            
                fileLink.href = fileURL;
                let fileName = "Additive-report.pdf";
                fileLink.setAttribute('download',fileName);
                document.body.appendChild(fileLink);
            
                fileLink.click();
            }else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
            }
        })
    }
  }
}

</script>

<template>
  <main>
    <div class="grid">
        <div class="col-12 lg:col-2">
            <label for="from" :class="{'p-error':v$.filters.from.$invalid && submitted}">{{$t('from')}}</label>
            <Calendar
                :class="{'p-invalid':v$.filters.from.$invalid && submitted, 'p-inputtext-sm w-full': true}"
                :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                :dateFormat="constants.DATE_FORMAT_POINT"
                :showTime="false"
                v-model="filters.from"
                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
            </div>
            <div v-if="(v$.filters.from.$invalid && submitted) || v$.filters.from.$pending.$response">
                <small class="p-error" v-for="error in v$.filters.from.$silentErrors" :key="error.$validator">
                    {{error.$message}}
                </small>
            </div>
        <div class="col-12 lg:col-2">
            <label for="to" :class="{'p-error':v$.filters.to.$invalid && submitted}">{{$t('to')}}</label>
            <Calendar
                :class="{'p-invalid':v$.filters.to.$invalid && submitted, 'p-inputtext-sm w-full': true}"
                :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                :dateFormat="constants.DATE_FORMAT_POINT"
                :showTime="false"
                v-model="filters.to"
                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
            <div v-if="(v$.filters.to.$invalid && submitted) || v$.filters.to.$pending.$response">
                <small class="p-error" v-for="error in v$.filters.to.$silentErrors" :key="error.$validator">
                    {{error.$message}}
                </small>
            </div>
        </div>
        <div class="col-12 lg:col-2">
            <label for="plant">{{$t('registryPlant.fk')}}</label>
            <GenericCustomMasterDataAutocompleteV2
                field="label"
                v-model="filters.idRegistryPlant"
                api="masterdata/registry-plant-combo"
                :addEmpty="true"
                :emptyValue="null"
                :emptyLabel="$t('all')"
                :name="'registry-plant'"
                :class="{'p-inputtext-sm w-full': true}" />
        </div>
        <div class="col-12 lg:col-2"> 
          <label for="type">{{$t('AdditiveReport.reportType')}}</label>
          <Dropdown v-model="additiveDenaturing" :options="additiveDenaturingOptions" optionLabel="label" optionValue="value" :class="{'p-inputtext-sm w-full': true}">
            <template #value="slotProps">
                <div v-if="slotProps.value" class="flex align-items-center">
                    <div>{{ slotProps.value == 'DENATURING' ? $t('AdditiveReport.denaturing') : $t('AdditiveReport.additive')}}</div>
                </div>
            </template>
            <template #option="slotProps">
                <div class="flex align-items-center">
                    <div>{{ $t(slotProps.option.label) }}</div>
                </div>
            </template>
        </Dropdown>
        </div>
        <div class="col-12 lg:col-6">
            <div class="p-4">
                <ResponsiveButton :label="$t('btn.search')" icon="pi pi-search" class="mx-1" @click="load()"/>   
                <ResponsiveButton :label="$t('btn.download')" icon="pi pi-download" class="mx-1" @click="dowloadReport"/>   
            </div>
        </div>
        <div class="col-12" style="height: calc(75vh)">
            <GenericDataTable :configuration="configuration" :category="'fiscal-data'" :name="'additive'" ref="additiveReport"/>
        </div>
    </div>
  </main>
</template>